import {Button, Table} from "antd";
import React from "react";
import {SwapOutlined} from "@ant-design/icons";

const {Column} = Table;

type Props = {
  loading: boolean,
  data: any[],
  getMatchDetail: Function,
  showLog: Function,
  showMatchDetail: Function,
}

const SportBetLogTable = ({loading, data, getMatchDetail, showLog, showMatchDetail} : Props) => {

  return (
    <Table
      className="mt-4"
      rowKey='id' size="small" bordered loading={loading} dataSource={data}
      pagination={false}>

      <Column title="No." align='center' render={(_text, _record, index) => index + 1}/>
      <Column title="GID" align='center' render={(_, record: any) => (
        <div>{record.detail?.order_no}</div>
      )}/>
      <Column title="Created at" dataIndex='created_at' key='created_at' align='center'/>
      <Column title="Username"  render={(_, record: any) => (
        <div className='ml-2 text-red-600 cursor-pointer underline' >{record.username?.toUpperCase()}</div>
      )}/>
      <Column title="Ext Count" align="center" key="logs_count" dataIndex="logs_count" render={(_, record: any) => (
        <div>{record.detail?.biz_status?.split("_")[0]}
          <span className='ml-2 text-xs text-red-600 cursor-pointer' onClick={() => showLog(record.id)}>
            ({record.logs_count} <SwapOutlined />)
          </span>
        </div>
      )}/>
      <Column title="Matches" align='center'
              render={(_, record: any) => {
                if (record.detail?.detail != null) {
                  const detail = JSON.parse(record.detail?.detail)
                  if(detail.data.detailList != null) {
                    return <span className="underline text-red-600 cursor-pointer" onClick={() => showMatchDetail(detail.data)}>
                      {detail.data.detailList.length} x Matches
                    </span>
                  }
                  return <pre>{JSON.stringify(detail.data, null, 2)}</pre>
                }

                return <Button onClick={() => {getMatchDetail(record.detail?.order_no)}}
                               danger size='small' type="text">Get Detail</Button>
              }}/>

      <Column title="End Balance" dataIndex='end_balance' key='end_balance' align='right'
              render={text => <span>{Number(text).toLocaleString()}</span>}/>

      <Column title="Bet Amount" dataIndex='bet_amount' key='bet_amount' align='right'
              render={text => <span>{Number(text).toLocaleString()}</span>}/>
      <Column title="Payout" dataIndex='win_amount' key='win_amount' align='right'
              render={(_, record: any) => {
                if (record.oustanding == 0) {
                  return <span>???</span>
                }
                return <span>{Number(record.win_amount).toLocaleString()}</span>
              }}
      />
    </Table>
  )
}

export default SportBetLogTable